import {
    AfterViewInit,
    Component,
    isDevMode, OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import {
    AppAlertService, FormsService,
    ParametersService,
    RegistrationNewModuleService, SettingsService,
    SubtitlesService, ViewsService,
} from "../../core";
import {RecaptchaComponent} from "ng-recaptcha";
import {CountryData} from "../../models";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Subscription} from "rxjs";

@Component({
    selector: 'registration-new-module',
    templateUrl: './registration-new-module.component.html',
    styleUrls: ['./registration-new-module.component.scss']
})
export class RegistrationNewModuleComponent implements OnInit, AfterViewInit, OnDestroy {
    showRecaptcha: boolean = true;
    newModuleForm: FormGroup;
    private newModuleNameSub: Subscription | undefined;
    private registerCodeSub: Subscription | undefined;
    private postcodePolicySub: Subscription | undefined;
    private countrySub: Subscription | undefined;
    private zipCodeSub: Subscription | undefined;
    private notificationEmailSub: Subscription | undefined;
    private additionalInformationSub: Subscription | undefined;
    @ViewChild('captchaRef') captchaComponent?: RecaptchaComponent;

    constructor(
        private appAlert: AppAlertService,
        private fb: FormBuilder,
        public forms: FormsService,
        public parameters: ParametersService,
        public settings: SettingsService,
        private subtitles: SubtitlesService,
        public registrationNewModule: RegistrationNewModuleService,
        public views: ViewsService,
    ) {
    }

    ngOnInit() {
        this.showRecaptcha = !isDevMode();
        if(isDevMode()){
            this.forms.validCaptcha = true;
            this.forms.captcha = 'test';
        }
        if (this.forms.allCountries.length === 0) {
            this.forms.getCountryInitial();
        }
        this.newModuleForm = this.fb.group({
            newModuleName: [null as null | boolean, [Validators.minLength(2), Validators.maxLength(40)]],
            registerCode: [null as null | number, [Validators.required, Validators.min(10000), Validators.max(99999)]],
            postcodePolicy:[null as null | boolean],
            country: [null as null | CountryData],
            zipCode: [null as null | string, this.settings.zipCodeValidator()],
            notificationEmail: [null as null | string, [Validators.email]],
            additionalInformation: [null as null | string, [Validators.minLength(2), Validators.maxLength(40)]],
        });
        this.newModuleForm.patchValue({
            newModuleName: this.registrationNewModule.moduleInfo,
            registerCode: this.registrationNewModule.registerCode,
            postcodePolicy: this.registrationNewModule.acceptPostcodePolicy,
            country: this.registrationNewModule.selectedCountry,
            zipCode: this.registrationNewModule.zipCode,
            notificationEmail: this.registrationNewModule.email,
            additionalInformation: this.registrationNewModule.additionalInformation,
        });
        this.newModuleNameSub = this.newModuleForm.get('newModuleName').valueChanges.subscribe( value => {
          this.registrationNewModule.moduleInfo = value;
        });
        this.registerCodeSub = this.newModuleForm.get('registerCode').valueChanges.subscribe( value => {
          this.registrationNewModule.registerCode = value;
        });
        this.postcodePolicySub = this.newModuleForm.get('postcodePolicy').valueChanges.subscribe( value => {
            this.registrationNewModule.acceptPostcodePolicy = value;
        });
        this.countrySub = this.newModuleForm.get('country').valueChanges.subscribe( value => {
            this.registrationNewModule.selectedCountry = value;
        });
        this.zipCodeSub = this.newModuleForm.get('zipCode').valueChanges.subscribe( value => {
            this.registrationNewModule.zipCode = value;
        });
        this.notificationEmailSub = this.newModuleForm.get('notificationEmail').valueChanges.subscribe( value => {
            this.registrationNewModule.email = value;
        });
        this.additionalInformationSub = this.newModuleForm.get('additionalInformation').valueChanges.subscribe( value => {
            this.registrationNewModule.additionalInformation = value;
        });
    }

    ngAfterViewInit() {
        this.views.checkCaptchaIsReady();
    }

    ngOnDestroy() {
        this.views.hideCaptchaLoader();
        this.newModuleNameSub?.unsubscribe();
        this.registerCodeSub?.unsubscribe();
        this.postcodePolicySub?.unsubscribe();
        this.countrySub?.unsubscribe();
        this.zipCodeSub?.unsubscribe();
        this.notificationEmailSub?.unsubscribe();
        this.additionalInformationSub?.unsubscribe();
    }

    get newModuleNameControl() {
        return this.newModuleForm.get('newModuleName') as FormControl;
    }

    get registerCodeControl() {
        return this.newModuleForm.get('registerCode') as FormControl;
    }

    get postcodePolicyControl() {
        return this.newModuleForm.get('postcodePolicy') as FormControl;
    }

    get countryControl() {
        return this.newModuleForm.get('country') as FormControl;
    }

    get zipCodeControl() {
        return this.newModuleForm.get('zipCode') as FormControl;
    }

    get notificationEmailControl() {
        return this.newModuleForm.get('notificationEmail') as FormControl;
    }

    get additionalInformationControl() {
        return this.newModuleForm.get('additionalInformation') as FormControl;
    }

    isPostCodePolicyAccepted(): boolean {
        return this.postcodePolicyControl.value === true;
    }

    resolved(captchaResponse: string) {
        this.forms.captcha = captchaResponse;
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }

    registerModule(): void {
        if (this.parameters.demoAccount()) {
            this.appAlert.openDemoAccountDialog();
        } else {
            this.registrationNewModule.registerModule()
        }
    }
}
